<template>
  <v-dialog v-model="DIALOG_ATIVO" :retain-focus="false" persistent :width="largura" fullscreen :transition="transition">
    <v-card>
      <v-card-title id="titulo">
        <slot name="titulo">
          <v-btn icon class="ml-n2 mr-5" dark @click="fechar">
            <v-icon>mdi-close</v-icon>
          </v-btn>

          <slot name="titulo.text">
            {{ titulo }}
          </slot>

          <slot name="titulo-append">
            <!-- appendar conteudo apos o titulo -->
          </slot>

          <v-spacer />

          <slot name="titulo-parte-direita">
            <p class="pa-0 ma-0 font-weight-regular" style="font-size: 16px">
              {{txtTituloLadoTireito}}
            </p>
          </slot>
        </slot>
      </v-card-title>

      <v-divider />

      <v-card-text class="pa-0 ma-0">
        <slot>v-slot:default</slot>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'SysDialogFullscreen',
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    titulo: {
      type: [String, Number],
      default: "prop:titulo"
    },
    txtTituloLadoTireito: {
      type: [String, Number],
      default: ""
    },
    largura: {
      type: [String, Number],
      default: 600
    },
    txtBotao: {
      type: String,
      default: 'salvar'
    },
    transition: {
      type: String,
      default: 'dialog-bottom-transition'
    }
  },
  emits: ['click:hidden-dialog'],
  computed: {
    DIALOG_ATIVO: {
      get(){ return this.modelValue },
      set(valor){ this.$emit('update:modelValue', valor) }
    }
  },
  methods: {
    fechar () {
      this.$emit('update:modelValue', false)
      this.$emit('click:hidden-dialog', {})
    }
  }
}
</script>

<style scoped>
#titulo {
  height: 60px;
  background: #0a3950;
  color: white;
  padding: 0 10px 0 20px;
  align-items: center;
}
</style>
